(function(angular) {
    'use strict';
    angular.module('nucleus.bm-help-widget')
        .service('HelpService', ['$q', '$http',
            function HelpService($q, $http) {
                function configAndCallEndpoint(handler, endpoint) {
                    var config = {
                        url: endpoint,
                        method: 'GET',
                        cache: true
                    };

                    return $http(config).then(
                        function callEndpoint(resp) {
                            var defer = $q.defer();
                            defer.resolve(handler(resp));
                            return defer.promise;
                        },
                        function endpointFailed(resp) {
                            resp.config.global = false;
                            return $q.reject(resp);
                        });
                }

                return {
                    loadVideos: function loadVideos() {

                        var endpoint = '/api/profiles/v1/help/getting-started/videos';

                        function handleGetVideos(evt) {
                            if (evt.data === null || evt.data.videos === null) {
                                return;
                            }

                            var videos = evt.data.videos;
                            var baseUrl = evt.data.baseUrl;
                            var helpVideos = [];

                            for (var counter = 0; counter < videos.length; counter++) {
                                helpVideos.push({
                                    title: videos[counter].title,
                                    length: videos[counter].length,
                                    description: videos[counter].description,
                                    dialog: 'gs-video-' + counter,
                                    url: getMungedUrl(baseUrl, videos[counter].url)
                                });
                            }
                            // placeholders for now
                            return helpVideos;
                        }

                        function getMungedUrl(base, relative) {
                            // chop off ending slash
                            if (base.lastIndexOf('/') === base.length - 1) {
                                base = base.slice(0, -1);
                            }

                            var baseParts = base.split('/');
                            var relativeParts = relative.split('/');
                            var previousDirCount = 0;

                            for (var counter = 0; counter < relativeParts.length; counter++) {
                                if (relativeParts[counter] === '..') {
                                    previousDirCount++;
                                    continue;
                                }
                                break;
                            }

                            if (previousDirCount > 0) {
                                // move back in the directory structure (i.e. ../..)
                                baseParts = baseParts.slice(0, baseParts.length - previousDirCount);
                                // kill off the previous directory strings (i.e. ..)
                                relativeParts = relativeParts.slice(previousDirCount);
                            }

                            // munge the 2 urls
                            return baseParts.join('/') + '/' + relativeParts.join('/');
                        }

                        return configAndCallEndpoint(handleGetVideos, endpoint);

                    },
                    loadTopics: function loadTopics() {
                        var endpoint = '/api/profiles/v1/help/getting-started/topics';

                        function handleGetTopics(evt) {
                            if (evt.data === null || evt.data.topics === null) {
                                return;
                            }

                            var topics = evt.data.topics;
                            var baseUrl = evt.data.baseUrl;
                            var helpTopics = [];

                            for (var counter = 0; counter < topics.length; counter++) {
                                helpTopics.push({ id: counter, name: topics[counter].title, url: baseUrl + topics[counter].url });
                            }

                            return helpTopics;
                        }

                        return configAndCallEndpoint(handleGetTopics, endpoint);
                    }
                };
            }
        ]);
})(window.angular);
